import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import TagManager from 'react-gtm-module';
import { useRouter } from 'next/router';
import LayoutContainer from 'components/layout/LayoutContainer';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { Breadcrumbs, ContainerVideo } from 'components/widgets';
import MembersCarousel from '../../src/components/about/MembersCarousel';
import { companyMembers } from '../../src/components/utils/companyMembers';

const serverUrlImages = process.env.REACT_APP_SERVER_URL_IMAGES;

//const videoImg = `${serverUrlImages}/about-as/ciudad-de-mexico.png`;
const txtVision = `${serverUrlImages}/about-as/VISION-TEXT.svg`;
const txtMision = `${serverUrlImages}/about-as/MISION-TEXT.svg`;

const AboutUsPage = () => {
	const router = useRouter();
	const canonicalURL =
		process.env.REACT_APP_DOMAIN_URL + (router?.asPath || router?.pathname);

	const [showVideo, setShowVideo] = useState(false);

	const _calculateAge = () => {
		let today = new Date();
		let birthDate = new Date('2004/06/01');
		let _age = today.getFullYear() - birthDate.getFullYear();
		let monthToday = today.getMonth() + 1;
		let monthBirthDate = birthDate.getMonth() + 1;
		let m = monthToday - monthBirthDate;
		if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
			_age--;
		}
		return _age;
	};

	const age = _calculateAge();

	const [routes] = useState([
		{
			name: 'Inicio',
			pathname: '/',
			asPath: '/'
		},
		{
			name: 'Quiénes somos',
			pathname: router?.pathname,
			asPath: router?.asPath
		}
	]);

	useEffect(() => {
		const tagManagerArgs = {
			dataLayer: {
				event: 'pageview',
				pageTitle:
					'¿Quiénes están detrás de asistensi, el mejor seguro para emergencias médicas?'
			}
		};
		TagManager.dataLayer(tagManagerArgs);
	}, []);

	const handleVideo = (_showVideo) => setShowVideo(_showVideo);

	const styles = {
		vision:{
			transform: 'translateZ(0)',
			maxHeight: '540px',
			backgroundColor: '#211B42'
		},
		visionTxt:{
			maxHeight: '180px',
			marginLeft: '40%'
		},
		misionTxt:{
			maxHeight: '200px',
			minHeight: '130px'
		},
		mision:{
			transform: 'translateZ(0)',
			maxHeight: '540px',
			backgroundColor: '#E72956'
		}
	  };

	return (
		<LayoutContainer>
			<style jsx global>
				{`
					.img-rotate {
						transform: rotateY(180deg);
					}
				`}
			</style>
			<div className="content">
				<Head>
					<title>
						¿Quiénes están detrás de asistensi, el mejor seguro para emergencias
						médicas?{' '}
					</title>
					<meta
						name="description"
						content={`Detrás de asistensi hay un grupo de profesionales en atención primaria y seguros para emergencias médicas con más de ${age} años de experiencia cuidando la salud de las familias de quienes han emigrado.`}
					/>
					<link rel="canonical" href={canonicalURL} />
				</Head>
				<div className="mt-12 h-full">
					<div className="bg-pink-500 flex flex-col items-center justify-center text-center py-16">
						<h1 className="font-poppins text-white text-center font-bold container leading-snug text-4xl sm:text-5xl">
							¿Quiénes somos?
						</h1>
					</div>
					<Breadcrumbs routes={routes} />
					{/* About asistensi */}
					<div className="container mt-10">
						<div className="flex flex-col md:flex-row">
							<div className="md:w-1/2">
								<div className="font-poppins text-purple-500 font-bold text-3xl">
								Nuestro propósito es que nadie se quede sin acceso a la salud
								</div>
								<div className="about-asistensi-paragraphs">
									<p className="text-base text-justify text-gray-800 my-4">
										Somos una compañía que ofrece planes de salud accesibles que incluyen servicios y seguros de calidad para proteger frente a los malestares del día a día, enfermedades comunes y emergencias médicas.
									</p>

									<p className="text-base text-justify text-gray-800 my-4">
										En <span className="text-pink-500 font-bold">asistensi </span>{" "} estamos enfocados en apoyar principalmente a quienes han emigrado para que puedan seguir cuidando de sus seres queridos en sus países de origen sin importar las distancias.
									</p>

									<p className="text-base text-justify text-gray-800 my-4">
										Nuestra sede global está en Venezuela y tenemos operaciones en Latinoamérica, desde donde cuidamos a los familiares de los migrantes que residen por todo el mundo.
									</p>
									
								</div>
							</div>
							<div className="md:w-1/2 md:px-8">
								<div
									className="overflow-hidden relative bg-cover bg-center bg-no-repeat h-68 w-full rounded flex justify-center items-center"
									// style={{ backgroundImage: `url('${videoImg}')` }}
								>
									<iframe className="h-full w-full absolute top-0 left-0" src="https://www.youtube.com/embed/0Ego2VkbM0I" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; web-share" allowfullscreen></iframe>
									{/* <div className="bg-purple-500 bg-opacity-25 h-full w-full absolute top-0 left-0"></div>
									<PlayArrowIcon
										className="text-pink-500 cursor-pointer rounded-full bg-white p-2 z-10 md-icon"
										onClick={() => handleVideo(true)}
									/> */}
								</div> 
								  {/* {showVideo === true && (
									<ContainerVideo
										src="https://player.vimeo.com/video/458398684?autoplay=1&playsinline=1"
										handleClose={handleVideo}
									/>
								)}  */}
							</div>
						</div>
					</div>

					{/* Team asistensi */}
					<div>
						{/* <h2 className="font-poppins text-purple-500 text-center font-bold leading-snug text-4xl px-8">
						Comprometidos con el cuidado de la salud de los tuyos
						</h2> */}
						<div className="bg-gray-100 py-8">
							{/* <MembersCarousel members={companyMembers} /> */}

							<div className="flex flex-col md:flex-row container">
								<div className="w-full md:w-1/2 text-gray-800 text-justify text-base md:pr-4 mb-4 md:mb-0">
									En <span className="text-pink-500 font-bold">asistensi </span>{' '}
									somos un equipo multidisciplinario integrado por médicos y profesionales especializados en servicios asistenciales de salud 
									y seguros médicos. Estamos orientados a mejorar la calidad de vida y la tranquilidad de nuestros miembros, 
									buscando todas las soluciones posibles para apoyarlos, sin importar las distancias.
								</div>
								<div className="w-full md:w-1/2 text-gray-800 text-justify text-base md:pl-4">
									Contamos con médicos generales y paramédicos certificados entrenados para brindar la mejor atención y 
									un equipo operativo que se encarga de que <span className="text-pink-500 font-bold">asistensi </span>{' '} 
									siempre cumpla con los más altos estándares de calidad.
								</div>
							</div>
						</div>
					</div>
					{/* VISION */}
					<div
						className="w-full relative flex flex-col items-center"
						style={styles.vision}
					>	
						<div className="container flex flex-col items-end sm:py-20 md:py-6">
							<img
								src={txtVision}
								style={styles.visionTxt}
								alt="Vision"
								className="my-5"
							/>
						</div>
					</div>
					{/* MISION */}
					<div className="w-full relative flex flex-col items-center"
					style={styles.mision}>
						<div className="container flex flex-col items-start sm:py-20 md:py-6">
							<img
								src={txtMision}
								style={styles.misionTxt}
								alt="Mision"
								className="my-5"
							/>
						</div>
					</div>
				</div>
			</div>
		</LayoutContainer>
	);
};

export default AboutUsPage;
